import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { get } from 'lodash';
import { filter } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoggerService } from './logger.service';
import { TaggedLogger } from './taggedLogger';
// todo: get actual defs if possible
declare let gtag: Function;

declare global {
  interface Window {
    dataLayer: any;
    gtag: Function;
  }
}

/**
 * Handles GTM interactions
 */
@Injectable({ providedIn: 'root' })
export class GoogleAnalyticsService {
  private readonly gtmId: string;

  private warned = false;

  private logger: TaggedLogger;

  constructor(private router: Router, loggerService: LoggerService) {
    this.logger = loggerService.taggedLogger('GoogleAnalytics');
    this.gtmId = get(environment, 'gtm.id', '');
  }

  init() {
    this.logger.trace('init()');
    // todo: check out GTM, this doesn't seem right.
    // was previously in app.component.html ngOnInit
    // Is firing a configure event on every page change
    // More likely, it should be firing a page event
    // there's probably something hacky going on in the GTM config, likely causing odd behavior
    // This might have been an attempt at a landing page event, or it might be unnecessary
    // todo: config should also have some global attributes (environment), might be coerced in the container.

    if (!this.gtmId) return this.noGTMIDWarning();

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.logger.trace('config', { id: this.gtmId, page_path: event.urlAfterRedirects });
        gtag('config', this.gtmId, {
          page_path: event.urlAfterRedirects,
        });
      });

    this.logger.trace('init() finished');
  }

  /**
   * Emits an event to GTM
   * todo: rename to just 'event'
   * @param eventName The event's name
   * @param eventCategory The event's category
   * @param eventAction The event's action
   * @param eventLabel The event's label
   * @param eventValue The event's value
   */
  public eventEmitter(
    eventName: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string = null,
    eventValue: number = null,
  ) {
    if (!this.gtmId) return this.noGTMIDWarning();

    const params = {
      eventCategory,
      // eventAction,
      eventLabel,
      eventValue,
    };

    this.gtag('event', eventName, params);
  }

  /**
   * Calls gtag, ensures that if it does not exist (has not been bootstrapped) that the fallback is used.
   * @param args
   */
  gtag(...args: any[]) {
    if (!window.gtag || typeof window.gtag !== 'function' || !window.dataLayer) {
      this.initGtagStub();
    }

    this.logger.trace('gtag()', args);
    window.gtag(...args);
  }

  private initGtagStub() {
    this.logger.trace('Init GTM Stub');
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
  }

  private noGTMIDWarning() {
    if (this.warned) return;

    this.logger.warn('No GTM ID for this environment');
    this.warned = true;
  }
}
